(() => {
  const name = 'quickCart';

  App.common = App.common || {};

  App.common[name] = (() => {
    const productCount = 0;
    let $basketHeader = null;
    let $basketHeaderWrap = null;
    const $basketHeaderContent = $('#basketContent');
    const isTouchDevice = App.global.isTouchDevice();
    let quickCartItemsQuantity = 0;
    const isMobile = App.global.isMobile();
    const isCartPage = App.currentPage === 'cartPage';

    const cartAndFavoritesSelector = '[data-cart-and-favorites]';
    const quickcartCartButtonSelector = '[data-quick-cart-button]';
    const quickcartCountSelector = '[data-quick-cart-count]';
    const quickcartCloseSelector = '[data-quick-cart-close-button]';
    let $quickcartBottomWrapper;

    const quickcartSummaryTemplate = JST['quick-cart-summary'];

    function renderListScrollIndicator() {
      const maxShadowPx = 80;
      // eslint-disable-next-line max-len
      let scrollLength = ($basketHeaderContent[0].scrollHeight - $basketHeaderContent.innerHeight() - $basketHeaderContent[0].scrollTop) / 2;
      if (scrollLength >= 0) {
        scrollLength = scrollLength > maxShadowPx ? maxShadowPx : scrollLength;
        $quickcartBottomWrapper.css({
          'box-shadow': `0 0 ${scrollLength}px ${scrollLength * 0.8}px #fff`,
        });
      }
    }

    function clickOutsideCartHandler(e) {
      const $target = $(e.target);
      if (!$target.closest($basketHeaderWrap).length
        && !$target.is('#cancelButton')
        && !$target.is('#okButton')
        && $basketHeaderWrap.is(':visible')
        && $basketHeaderWrap.css('opacity') === '1') {
        // eslint-disable-next-line no-use-before-define
        hideQuickCart();
      }
    }

    function hideQuickCart() {
      if (App.global.isMobile()) {
        App.common.header.allowDocumentScroll();
      }
      $('.top-menu-wrapper').attr('data-cart-state', 'closed');

      document.removeEventListener('click', clickOutsideCartHandler);
    }

    function showQuickCart() {
      if (isCartPage) {
        return;
      }
      if (App.global.isMobile()) {
        App.common.header.preventDocumentScroll();
      }

      $('.top-menu-wrapper').attr('data-cart-state', 'open');
      setTimeout(() => {
        document.addEventListener('click', clickOutsideCartHandler);
      }, 200);

      renderListScrollIndicator();

      App.eventBus.trigger('quickcart:opened');
    }

    const updateQuickCartPriceSummary = function (orderPriceInfo) {
      $('#quickcart-price-summary')
        .html(orderPriceInfo ? $(quickcartSummaryTemplate(orderPriceInfo)) : '');
    };

    const updateQuickCartProductCount = function (totalItemsInCart) {
      const $topMenu = $(cartAndFavoritesSelector);
      if (totalItemsInCart > 0) {
        $topMenu.attr('data-has-cart-items', '');
        $(quickcartCountSelector).html(totalItemsInCart);
      } else if (totalItemsInCart === 0 && $topMenu.is('[data-has-cart-items]')) {
        $topMenu.removeAttr('data-has-cart-items');
        $(quickcartCountSelector).html('0');
        hideQuickCart();

        $(quickcartCartButtonSelector)
          .addClass('animation--shake')
          .delay(1000)
          .queue(function dequeueAnimationShake() {
            $(this)
              .removeClass('animation--shake')
              .dequeue();
          });
      } else {
        $(quickcartCountSelector).html(totalItemsInCart);
      }
      $topMenu.attr('data-cart-data-loaded', '');
    };

    const updateQuickCartSummary = () => {
      const { mainOrderInfo, quickCartOrderInfo } = window.dataLayer || {};
      if (quickCartOrderInfo) {
        updateQuickCartProductCount(quickCartOrderInfo.totalItemsInCart);
        updateQuickCartPriceSummary(quickCartOrderInfo.orderPriceInfo);
      } else if (isCartPage && mainOrderInfo) {
        updateQuickCartProductCount(mainOrderInfo.totalItemsInCart);
        updateQuickCartPriceSummary(mainOrderInfo.orderPriceInfo);
      }
    };

    const setAllowQuickCartCookie = (allowQuickCart = true) => {
      App.global.setCookie('allowQuickCart', allowQuickCart, '/');
    };

    const setQuickCartItems = function (data) {
      if (data) {
        window.dataLayer.quickCartOrderInfo = data;
        setAllowQuickCartCookie(data.cartItems.length > 0);
      }
    };

    // Disable caching in IE10-11!
    const getQuickCartContent = async () => {
      const allowQuickCart = JSON.parse(App.global.getCookie('allowQuickCart'));
      // Need to check for quick cart content if cookie does not exist
      if (allowQuickCart === true || allowQuickCart === null) {
        try {
          const result = await $.ajax({
            cache: false,
            method: 'GET',
            url: '/quickcarts/default',
            dataType: 'json',
          });
          setAllowQuickCartCookie(result && result.totalItemsInCart > 0);
          return result;
        } catch (err) {
          App.sendErrorToRaygun(err);
        }
      }
      return null;
    };

    const applyBasketAnimation = function (quantityAfterUpdate) {
      if (quickCartItemsQuantity < quantityAfterUpdate) {
        // TODO: Fix in DS-129
        // $basketIcon.addClass('pulse');
      }
      quickCartItemsQuantity = quantityAfterUpdate;
    };

    const countCartItemsQuantity = function (data) {
      const len = data.cartItems.length;
      let quantity = 0;
      for (let i = 0; i < len; i += 1) {
        quantity += data.cartItems[i].quantity;
      }
      return quantity;
    };

    const renderQuickCart = (cartItems = []) => {
      if (!isCartPage) {
        const $tempContainer = $('<div/>');
        cartItems.forEach((item) => {
          const newItemConfig = App.cartPage.fillUpOrderRowConfig(item);
          const newItem = App.cartPage.orderModel.createQuickCartItem(newItemConfig);
          $tempContainer.append(newItem.element);
          App.cartPage.orders[newItem.tempHash] = newItem;
        });
        $basketHeaderContent.html($tempContainer.children());
      }
    };

    const update = async () => {
      const res = await App.cartPage.services.updateQuickCart();
      if (res) {
        if (isCartPage) {
          window.dataLayer.mainOrderInfo = res;
        }

        setQuickCartItems(res);
        renderQuickCart(res.cartItems);
        if (isMobile && !isCartPage) {
          const quantity = countCartItemsQuantity(res);
          applyBasketAnimation(quantity);
        }
        updateQuickCartSummary();
        return res;
      }
      return null;
    };

    const refreshContent = async () => {
      if (!isCartPage) {
        const res = await getQuickCartContent();
        if (res) {
          setQuickCartItems(res);
          renderQuickCart(res.cartItems);
          if (isMobile) {
            quickCartItemsQuantity = countCartItemsQuantity(res);
          }
          updateQuickCartSummary();
        }
      }
    };

    function checkPageOffers(e) {
      e.preventDefault();
      App.productPage.addToCart.checkOffers({
        defaultName: null,
        bucketCount: productCount,
      });
    }

    function checkMobileOffers(e) {
      e.preventDefault();
      if (!$(this).hasClass('active')) {
        checkPageOffers(e);
      }
    }

    function getCartItemCount() {
      return $basketHeaderContent.children().length;
    }

    function initBasketHandler() {
      $basketHeaderContent
        .on('mousewheel DOMMouseScroll', function basketHeaderContentOnMouseScroll(e) {
          let scrollTo = null;
          const $this = $(this);

          if (e.type === 'mousewheel') {
            scrollTo = (e.originalEvent.wheelDelta * -1);
          } else if (e.type === 'DOMMouseScroll') {
            scrollTo = 40 * e.originalEvent.detail;
          }
          if (scrollTo) {
            e.preventDefault();
            $this.scrollTop(scrollTo + $this.scrollTop());
          }
        })
        .on('click', '[data-delete-row]', App.cartPage.removeProductFromCart);

      if (!isTouchDevice || (isTouchDevice && App.global.isDesktop())) {
        $basketHeader.on('click', checkPageOffers);
      } else {
        $basketHeader.on('touchstart', checkMobileOffers);
      }
    }

    const rowAdded = async (event, data = {}) => {
      const {
        quickCartUpdate = true,
        quickCartOpen = !isCartPage,
      } = data;
      setAllowQuickCartCookie(true);
      if (quickCartUpdate) {
        App.eventBus.trigger('quickcart:update');
      }
      if (quickCartOpen) {
        App.eventBus.trigger('quickcart:open');
      }
    };

    const initEventListeners = () => {
      App.cartPage.setEventBusRemoveListeners();

      $(quickcartCartButtonSelector)
        .on('click', () => {
          if (getCartItemCount() > 0) {
            showQuickCart();
          } else {
            window.location = App.global.getRedirectUrl('/cart');
          }
        });

      $(quickcartCloseSelector)
        .on('click', () => {
          hideQuickCart();
        });

      $basketHeaderContent
        .on('scroll touchstart', () => {
          renderListScrollIndicator();
        });

      let mouseLeaveTimeout;
      $basketHeaderWrap
        .on('mouseleave', () => {
          mouseLeaveTimeout = setTimeout(hideQuickCart, 2000);
        })
        .on('mouseenter', () => {
          clearTimeout(mouseLeaveTimeout);
        });
    };

    const initEventBusListeners = () => {
      App.eventBus.on(`
        megamenu:opened 
        metamenu:opened 
        expandable-search:opened 
        burgermenu:opened 
        quickcart:close 
        ${!App.global.isMobile() ? 'page:scrolled' : ''}`, hideQuickCart);
      App.eventBus.on('quickcart:open', showQuickCart);
      App.eventBus.on('quickcart:update', refreshContent);
      App.eventBus.on('quickcart:row-added', rowAdded);
    };

    const priority = () => 0;

    const init = async () => {
      $basketHeader = $('.js-quick-cart');
      $basketHeaderWrap = $('#js-mobile-quick-cart');
      $quickcartBottomWrapper = $('.quick-cart__bottom-wrapper', $basketHeaderWrap);

      initEventBusListeners();
      if (isCartPage) {
        return;
      }

      initBasketHandler();
      initEventListeners();
      await refreshContent();
    };

    return {
      init,
      update,
      updateQuickCartSummary,
      clearTimeout,
      setAllowQuickCartCookie,
      priority,
    };
  })();
})();
